import { AgeingReport } from "@/pages/APAgeing";

export default function ARAgeing() {
  return (
    <AgeingReport
      title="AR Ageing"
      subtitle="Accounts receivable ageing — drill down Customer→WBS→Invoice or WBS→Customer→Invoice"
      endpoint="/reports/ar-ageing"
      exportKey="ar-ageing"
      drillOptions={[{ value: "customer", label: "Customer → WBS → Invoice" }, { value: "wbs", label: "WBS → Customer → Invoice" }, { value: "tbgroup", label: "TB Group → Customer → WBS → Invoice" }]}
      entityLabel="Customer Receivable"
      testPrefix="ar-ageing"
      partyType="ar"
      partyLabel="Customer"
    />
  );
}
